import { ADDFORMDATA, DELETESINGLEROW } from "./actionTypes";

const initialState = [];

const formReducer = (state = initialState, action) => {
    switch (action.type) {
        case ADDFORMDATA:
            const totalLength = state.length;

            if (totalLength <= 2) {
                return [
                    ...state,
                    action.payload
                ];
            }
            return state;
        case DELETESINGLEROW:
            const filterData = state.filter((single, i) => i !== action.payload)
            return filterData

        default:
            return state;
    }
};

export default formReducer;